export default __webpack_public_path__ + "static/media/logo.4e2730da.svg";